var map = {
	"./BlindMatch.png": 8771,
	"./Relu-Activation-Function.gif": 8066,
	"./acti.gif": 5475,
	"./activation-functions.gif": 3952,
	"./btc.gif": 8243,
	"./dbpred.gif": 137,
	"./examProctor.gif": 7876,
	"./facereco.gif": 6879,
	"./llm.gif": 4051,
	"./mern.png": 9153,
	"./neural.gif": 4708,
	"./news.gif": 8081,
	"./project-02.png": 1035,
	"./project-05.png": 6368,
	"./sr.gif": 6277,
	"./steg.jpg": 205,
	"./voice.gif": 5793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1937;